import { render, staticRenderFns } from "./top.vue?vue&type=template&id=0317a780&scoped=true&"
var script = {}
import style0 from "./top.vue?vue&type=style&index=0&id=0317a780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0317a780",
  null
  
)

export default component.exports